import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import styled from 'styled-components';
import Button from './Button';
import { DownloadIcon } from '@parchment/icons';
export const SCALE = /*#__PURE__*/Object.freeze({
  small: 'small',
  medium: 'medium',
  large: 'large'
});
export default function DownloadButton(_ref) {
  let {
    filePath,
    children = 'Download',
    name = 'download',
    scale = SCALE.medium,
    ...buttonProps
  } = _ref;

  /*
  * download attribute below is an anchor attribute used for handling download based links
  * download only works for same-origin URLs, or the blob: and data: schemes.
  * */
  return /*#__PURE__*/React.createElement(Button, _extends({
    href: filePath,
    scale: scale,
    download: true,
    name: name,
    as: "a"
  }, buttonProps), /*#__PURE__*/React.createElement(DownloadIcon, null), /*#__PURE__*/React.createElement(ButtonContent, null, children));
}
const ButtonContent = /*#__PURE__*/styled.span.withConfig({
  displayName: "DownloadButton__ButtonContent",
  componentId: "sc-3vdee2-0"
})(["margin-left:6px"]); // Looks like we are unable to adjust styles on Button for this possibly due to theme provider
// When we attempted to do a style button any default style being applied get lost.
// const DownloadButtonWrapper = styled(Button)` ***custom styles*** `;